import { ListHeaderFilterInput, ListHeaderFilterContainer } from '@/components/List'

import { useTexts } from '../../useTexts'

import { FilterByBadge } from './components/FilterByBadge/FilterByBadge'
import { useFilter } from './hooks/useFilter'

export function Filter() {
  const { query, setQuery, canFilterByBadge, noEntries } = useFilter()

  const texts = useTexts()

  const disabled = noEntries

  return (
    <ListHeaderFilterContainer>
      <ListHeaderFilterInput
        placeholder={texts.searchPlaceholder}
        setQuery={setQuery}
        testId="list-header-filter-input"
        query={query}
        disabled={disabled}
      />
      {canFilterByBadge && <FilterByBadge />}
    </ListHeaderFilterContainer>
  )
}
